import { Field } from "formik";
import { FormControl, Textarea, FormLabel, FormHelperText, FormErrorMessage } from "@chakra-ui/react";

export const TextareaField = ({name, label, placeholder, helperMessage,isRequired, ...rest}) => {
	return (
		<Field name={name} isRequired={isRequired}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[name] && form.touched[name]} mb="0.5em" isRequired={isRequired}>
          <FormLabel flexGrow={1} fontSize="0.9em">{label}</FormLabel>
          <Textarea {...field} {...rest} variant="outline" placeholder={placeholder} />
            {!form.errors[name] && helperMessage && (
            <FormHelperText mt="5px" color="blackAlpha.600" fontSize="0.8em">{helperMessage}</FormHelperText>)
          }
          <FormErrorMessage>{form.errors[name]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
	);
};